module.exports = __webpack_public_path__ + "c69943f0fb0822472f8819891af7050c.svg";